export const G = {
  black:     "#080a08",
  deep:      "#0d0f0d",
  surface:   "#131613",
  card:      "#181c18",
  border:    "#252a25",
  green:     "#4caf50",
  greenDim:  "#2e7d32",
  text:      "#d8dbd8",
  muted:     "#6a7a6a",
  white:     "#f0f2f0",
  greenGlow: "rgba(76,175,80,0.08)",
};
